<template>
  <el-form
    ref="form"
    :model="form"
    class="post-step__container"
  >
    <el-input class="post-step__title" disabled :placeholder="titlePlaceholder"/>

    <el-form-item prop="images">
      <el-upload
        class="w-100"
        :file-list="uploadFileList"
        :action="imageUploadUrl"
        :headers="headers"
        :on-remove="handleImageRemove"
        :on-error="handleImageError"
        :on-change="handleImageOnChange"
        :on-success="handleImageSuccess"
        :limit="4"
        :data="addToUploadRequest"
        ref="upload"
        list-type="picture"
        drag
      >
        <el-icon class="el-icon--upload">
          <i class="icon-picture text-black font-size-30"/>
        </el-icon>
        <div class="el-upload__text">
          {{ $t('post.add_photo') }}
        </div>
        <input class="paste-textarea" type="text">
      </el-upload>
    </el-form-item>
  </el-form>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {step} from '@/mixins/post/step';

export default {
  name: 'UploadImageStep',
  mixins: [step],
  computed: {
    ...mapGetters('auth', ['AUTH_TOKEN']),
    ...mapState('promo', {
      type: ({form}) => form.type,
      form: ({form}) => form,
    }),
    /**
     * Headers
     * @returns {{Authorization: string, Accept: string}}
     */
    headers() {
      return {'Accept': 'application/json', 'Authorization': 'Bearer ' + this.AUTH_TOKEN}
    },
    /**
     * Title placeholder
     * @returns {string}
     */
    titlePlaceholder() {
      return `${this.titleNumber}. ${this.$t('post.optional') + this.$t('post.steps.add_photo')}`
    },
    images: {
      get() { return this.form.images },
      set(value) { this.updateForm({ images: value }) }
    },
    uploadFileList() {
      return this.images.map((img, index) => ({
        name: img.name || `Image-${index + 1}`,
        url: img.url,
        status: 'success', // mark as already uploaded
        path: img.path,
      }));
    },
    addToUploadRequest() {
      return {
        target_disk: 's3',
      };
    }
  },
  data() {
    return {
      rules: {
        images: [
          {}
        ]
      },
      imageUploadUrl: process.env.VUE_APP_API_URL + 'posts/upload-image',
    }
  },
  mounted() {
    document.querySelector('.paste-textarea').focus()
  },
  methods: {
    handleImageError(err, file, files) {
      const e = JSON.parse(err.message);

      this.$notify.error({
        title: this.$t('notifications.default.title'),
        message: _.get(e, 'errors.file.0', this.$t('notifications.default.message')),
        position: this.notificationPosition,
        duration: this.notificationDuration,
      });
    },
    handleImageOnChange(file, files) {
      //
    },
    handleImageSuccess(response, file, fileList) {
      if (response.file && response.url) {
        const newImage = {
          name: file.name,
          url: response.url,
          path: response.file,
          disk: 's3',
        };

        // Combine with already uploaded ones (avoid duplicates by name or path)
        this.images = _.uniqBy([...this.images, newImage], 'path');
      }
    },
    handleImageRemove(file, fileList) {
      this.images = fileList.map(f => ({
        name: f.name,
        url: f.url,
        path: f.path,
        disk: f.disk,
      }));
    },
    reset() {
      this.$refs.upload.clearFiles();
    },
    /**
     * Validation
     * @returns {boolean}
     */
    async validate() {
      let result = false;

      await this.$refs.form.validate((isValid) => result = isValid)

      this.$emit('update', {titlesCount: 1})

      return result
    }
  },
}
</script>
